import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import LeftGroupList from "@/components/LeftGroupList";
import ButtonDialog from "@/components/ButtonDialog";
import api from "@/api";
export default {
  name: "KnotQuestionView",
  components: {
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      typeMap: {}
    };
  },
  methods: {
    deleteGroup() {
      api.deleteKnotGroup(this.groupId).then(() => {
        this.init();
      });
    },
    deleteKnotQuestion(qid) {
      api.deleteKnotQuestion(qid).then(() => {
        this.fetchList();
      });
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getKnotQuestionByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getKnotGroups().then(res => {
        this.groups = res.list.map(item => {
          return {
            ...item,
            label: item.groupName,
            text: item.groupName,
            value: item.id
          };
        });
        this.groupId = res.list[0].id;
        this.fetchList();
      });
      // api.getKnotQuestionTypeMap()
      //     .then(ret => {
      //       this.typeMap = ret;
      //     })
    }
  },
  mounted() {
    this.init();
  }
};